import { render, staticRenderFns } from "./Licitacije.vue?vue&type=template&id=f732b25a&"
import script from "./Licitacije.vue?vue&type=script&lang=js&"
export * from "./Licitacije.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports